import _Select from './base/Select';

import './style/index.js';

export type { SelectProps } from './base/Select';
export * from './type';

export const Select = _Select;
export default Select;
